import { Meta } from './meta.model'

export const signupPeriods = ['24h', '7d', '14d', '30d', '3m'] as const

export type SignupPeriod = (typeof signupPeriods)[number]

export const signupStatuses = ['free', 'buyers'] as const

export type SignupStatus = (typeof signupStatuses)[number]

export type SignupList = Array<{
	id: string
	name: string
	email: string
	phone: string | null
	whatsapp: string | null
	interest: string | null
	createdAt: string
	// Só vêm quando a situação é "buyers".
	purchasedClasses?: string | null
	firstPurchaseAt?: string | null
}>

export interface ListSignupResponse {
	data: SignupList
	meta: Meta
}

/**
 * Ou o atalho de período, ou o intervalo manual — nunca os dois: a API ignora as
 * datas quando o atalho chega, e mandar os dois esconderia isso da tela.
 */
export type SignupRange =
	| { period: SignupPeriod; startDate?: never; endDate?: never }
	| { period?: never; startDate: string; endDate: string }

export type SignupFilter = SignupRange & { status: SignupStatus }

export type ListSignupRequest = SignupFilter & { page: number }
